<template>
  <section class="box box--small-padding">
    <FetchJson :url="url">
      <template #default="{ json, loading }">
        <h2 class="box__header title-24">В среднем за день</h2>
        <div class="layout--horizontal" v-if="!loading">
          <ScalarIndicator
            title="Направлено заявлений"
            :value="Math.round(json.value * 10) / 10"
          ></ScalarIndicator>
        </div>
      </template>
    </FetchJson>
  </section>
</template>

<script>
import { computed, toRefs } from "vue";
import { dateToString } from "@/modules/date";
import ScalarIndicator from "@/components/infoblocks/ScalarIndicator";

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  components: {
    ScalarIndicator,
  },
  setup(props) {
    const filter = toRefs(props.filter);
    const url = computed(
      () =>
        `applications/send-method-daily-average?from=${dateToString(
          filter.from.value
        )}&to=${dateToString(filter.to.value)}&territory=${
          filter.territory.value.alias || ""
        }`
    );

    return {
      url,
    };
  },
};
</script>

<style lang="scss">
</style>
